(function($) {
    var sliderLeaderArrows = '.leader-pagination .slider-arrows';

    // Leader slider
    $('.slider-leader').slick({
        accessibility: false,
        appendArrows: sliderLeaderArrows,
        arrows: true,
        asNavFor: '.slider-leader-nav',
        fade: true,
        infinite: false,
        slide: '.slider-item',
        slidesToScroll: 1,
        slidesToShow: 1,
    });

    // Leader nav slider
    $('.slider-leader-nav').slick({
        // accessibility: false,
        arrows: false,
        asNavFor: '.slider-leader',
        dots: false,
        focusOnSelect: true,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 5,
        responsive: [{
            breakpoint: 1500,
            settings: {
                slidesToShow: 4,
            }
        },
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 4,
                }
            }
        ]
    });

})(jQuery);
